import React from 'react';
import { BaseCell } from '../../../../../../../components';
import { mechanismTypeMap } from '../../../RegrasDePreco/lib/data';
import { RuleDataItem } from '../../lib/service';

const RulesPageTableMechanismCell = ({ mechanism }: RuleDataItem) => {
  if (!mechanism?.mechanismType) return <BaseCell>--</BaseCell>;
  return <BaseCell>{mechanismTypeMap.get(mechanism.mechanismType)}</BaseCell>;
};

export default RulesPageTableMechanismCell;
